import { render, staticRenderFns } from "./BuyNow.vue?vue&type=template&id=cdb2c648&scoped=true"
import script from "./BuyNow.vue?vue&type=script&lang=js"
export * from "./BuyNow.vue?vue&type=script&lang=js"
import style0 from "./BuyNow.vue?vue&type=style&index=0&id=cdb2c648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb2c648",
  null
  
)

export default component.exports